import type { TourDefinition } from '../../types/tour';

export const workspaceSwitchFirstTour: TourDefinition = {
  key: 'workspace_switch_first',
  title: 'ワークスペース切替ツアー',
  steps: [
    {
      target: '#workspace-switcher-trigger',
      title: 'ワークスペース切替',
      content:
        'ヘッダーのこのボタンから他のワークスペースに切り替えできます。各ワークスペースは独立したダッシュボードを持ちます。',
      placement: 'bottom',
      disableBeacon: true,
    },
    {
      target: '#dashboard-widgets-area',
      title: '業種別ウィジェットの差分',
      content:
        '切り替えると、選んだ業種に応じたウィジェットに自動で差し替わります。営業なら商談パイプライン、採用なら候補者進捗が表示されます。',
      placement: 'top',
    },
  ],
};
